import { Event, GMW, UploadTask } from "@nens/brostar/openapi-client";
import {
  CreateGMWEventTask,
  EditGMWEventTask,
  RegistrationTypeOptions,
  qualityRegimeOptionsType,
  registrationTypeOptionsType,
} from "@nens/brostar/uploadapi-client";

import { isValidEnum } from "./is-valid-enum";

export const convertEventNameToRegistrationType = (eventName: string): RegistrationTypeOptions => {
  if (eventName === "nieuweBepalingMaaiveld") return "GMW_GroundLevel";
  if (eventName === "nieuweInmetingMaaiveld") return "GMW_GroundLevelMeasuring";
  if (eventName === "buisdeelIngeplaatst") return "GMW_Insertion";
  if (eventName === "buisOpgelengd") return "GMW_Lengthening";
  if (eventName === "onderhouderVeranderd") return "GMW_Maintainer";
  if (eventName === "eigenaarVeranderd") return "GMW_Owner";
  if (eventName === "nieuweBepalingPosities") return "GMW_Positions";
  if (eventName === "nieuweInmetingPosities") return "GMW_PositionsMeasuring";
  if (eventName === "opgeruimd") return "GMW_Removal";
  if (eventName === "maaiveldVerlegd") return "GMW_Shift";
  if (eventName === "buisIngekort") return "GMW_Shortening";
  if (eventName === "buisstatusVeranderd") return "GMW_TubeStatus";
  if (eventName === "beschermconstructieVeranderd") return "GMW_WellHeadProtector";
  if (eventName === "gerelateerdOnderzoek") return "GMW_SubsequentAdditionalSurvey";
  return "GMW_GroundLevelMeasuring";
};

// EDIT
export const convertGMWEventToEditTask = (object: Event, gmw: GMW): EditGMWEventTask => {
  const { sourcedocumentData, gmwBroId, metadata, eventDate } = object;
  const { qualityRegime } = gmw;
  const eventDateString = eventDate?.toISOString().split("T")[0];
  return {
    sourcedocumentData: {
      ...sourcedocumentData,
      eventDate: eventDateString, // Adds eventDate as a new key
    } as EditGMWEventTask["sourcedocumentData"],
    metadata: {
      broId: gmwBroId ?? "",
      projectNumber: "",
      correctionReason: "eigenCorrectie",
      deliveryAccountableParty: gmw.deliveryAccountableParty ?? "",
      qualityRegime: isValidEnum(qualityRegimeOptionsType, qualityRegime),
      ...metadata,
    },
    registrationType: convertEventNameToRegistrationType(object.eventName),
  } as EditGMWEventTask;
};

// UPLOAD TASK
export const convertGMWEventUploadTaskToCreateTask = ({
  projectNumber,
  registrationType,
  metadata,
  sourcedocumentData,
}: UploadTask): CreateGMWEventTask => {
  const { qualityRegime, deliveryAccountableParty, broId } = metadata as { [key: string]: string };

  return {
    registrationType: isValidEnum(registrationTypeOptionsType, registrationType),
    metadata: {
      deliveryAccountableParty: deliveryAccountableParty,
      qualityRegime: isValidEnum(qualityRegimeOptionsType, qualityRegime),
      projectNumber,
      broId,
    },
    sourcedocumentData: sourcedocumentData as CreateGMWEventTask["sourcedocumentData"],
  } as CreateGMWEventTask;
};
